import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './ocorrenciaForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';

import { 
	setModoTela, setFiltroPrincipal as setFiltro, initForm, salvar, excluir, getListaPrincipal as getLista, 
	getListaTipo, getListaMotorista, getListaGravidade, getListaLocal, 
	getListaResponsabilidade, getListaTipoCusto, salvarAbona, 
	getListaStatus, getListaAcao, getListaUsuario, getListaCategoria, getListaStatusGestao
} from './ocorrenciaActions';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';

class Ocorrencia extends Component {

	state = {
		linhaSelecionada: null,
		ordenacao: {
			datahora_ocorrencia: 1
		}
	}

    componentWillMount() {

		this.props.setModoTela('lista');

        this.props.getLista();
		this.props.getListaTipo();
		this.props.getListaMotorista();
		this.props.getListaGravidade();
		this.props.getListaLocal();
		this.props.getListaResponsabilidade();
		this.props.getListaTipoCusto();
		this.props.getListaStatus();
		this.props.getListaAcao();
		this.props.getListaUsuario();
		this.props.getListaCategoria();
		this.props.getListaStatusGestao();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form tratativa onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form tratativa excluir onSubmit={(registro) => this.props.excluir(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.props.lista.filter(item => {

			return !(this.props.filtro.pesquisar || '').trim()
				|| (this.props.filtro.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
				if (pesquisar
					&& !(`
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia)} 
					${item.nome_motorista} 
					${DateFormat.formatarDataSqlParaTela(item.data_admissao_motorista)}
					${item.nome_tipo} 
					${FormatUtils.formatarValorTela(item.percentual_desconto, 2)}
					${item.observacao} 
					${item.nome_usuario_inclusao}
					${item.nome_status_gestao}
				`).toUpperCase().includes(pesquisar)) {
					return false;
				}

				return true;

			}).length > 0;
			
		}).filter(item => {
			if (!this.props.usuarioCarregado) {
				return false;
			} else if (this.props.usuarioCarregado.acesso_ocorrencia) {
				return true;
			} else if (
				item.id_usuario_inclusao == this.props.usuarioCarregado.id
				|| item.id_usuario_responsavel == this.props.usuarioCarregado.id
				|| item.id_usuario_aprovador == this.props.usuarioCarregado.id
			) {
				return true;
			}
			return false;
		});

		if (this.state.ordenacao.datahora_ocorrencia) {
			lista.sort((a, b) => this.state.ordenacao.datahora_ocorrencia == 1 
				? (a.datahora_ocorrencia > b.datahora_ocorrencia ? 1 : -1) 
				: (a.datahora_ocorrencia > b.datahora_ocorrencia ? -1 : 1));
		} else if (this.state.ordenacao.nome_motorista) {
			lista.sort((a, b) => this.state.ordenacao.nome_motorista == 1 
				? (a.nome_motorista > b.nome_motorista ? 1 : -1) 
				: (a.nome_motorista > b.nome_motorista ? -1 : 1));
		} else if (this.state.ordenacao.data_admissao_motorista) {
			lista.sort((a, b) => this.state.ordenacao.data_admissao_motorista == 1 
				? (a.data_admissao_motorista > b.data_admissao_motorista ? 1 : -1) 
				: (a.data_admissao_motorista > b.data_admissao_motorista ? -1 : 1));
		} else if (this.state.ordenacao.nome_tipo) {
			lista.sort((a, b) => this.state.ordenacao.nome_tipo == 1 
				? (a.nome_tipo > b.nome_tipo ? 1 : -1) 
				: (a.nome_tipo > b.nome_tipo ? -1 : 1));
		} else if (this.state.ordenacao.percentual_desconto) {
			lista.sort((a, b) => this.state.ordenacao.percentual_desconto == 1 
				? (parseFloat(a.percentual_desconto || 0) > parseFloat(b.percentual_desconto || 0) ? 1 : -1) 
				: (parseFloat(a.percentual_desconto || 0) > parseFloat(b.percentual_desconto || 0) ? -1 : 1));
		} else if (this.state.ordenacao.observacao) {
			lista.sort((a, b) => this.state.ordenacao.observacao == 1 
				? (a.observacao > b.observacao ? 1 : -1) 
				: (a.observacao > b.observacao ? -1 : 1));
		} else if (this.state.ordenacao.nome_usuario_inclusao) {
			lista.sort((a, b) => this.state.ordenacao.nome_usuario_inclusao == 1 
				? (a.nome_usuario_inclusao > b.nome_usuario_inclusao ? 1 : -1) 
				: (a.nome_usuario_inclusao > b.nome_usuario_inclusao ? -1 : 1));
		} else if (this.state.ordenacao.abona) {
			lista.sort((a, b) => this.state.ordenacao.abona == 1 
				? ((a.abona ? 'SIM' : 'NÃO') > (b.abona ? 'SIM' : 'NÃO') ? 1 : -1) 
				: ((a.abona ? 'SIM' : 'NÃO') > (b.abona ? 'SIM' : 'NÃO') ? -1 : 1));
		} else if (this.state.ordenacao.nome_status_gestao) {
			lista.sort((a, b) => this.state.ordenacao.nome_status_gestao == 1 
				? (a.nome_status_gestao > b.nome_status_gestao ? 1 : -1) 
				: (a.nome_status_gestao > b.nome_status_gestao ? -1 : 1));
		} 

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.props.filtro.pesquisar}
							onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisar: value })} />

						<LabelAndInputDate
							label='Período Inicial'
							cols='12 6 4 4'
							value={this.props.filtro.data_inicial}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									data_inicial: value
								});
							}} />

						<LabelAndInputDate
							label='Período Final'
							cols='12 6 4 4'
							value={this.props.filtro.data_final}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									data_final: value
								});
							}} />

						<Select
							maxWidth={350}
							options={this.props.listaStatusGestao}
							label='Status'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_status}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_status: values.map(item => item.value)
								});
							}} />
								
						<Select
							maxWidth={350}
							options={this.props.listaMotorista}
							label='Motorista'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_motorista}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_motorista: values.map(item => item.value)
								});
							}} />

						<Select
							maxWidth={200}
							options={this.props.listaTipoOcorrrencia}
							label='Tipo'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_tipo_ocorrencia}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_tipo_ocorrencia: values.map(item => item.value)
								});
							}} />

						<Select
							maxWidth={350}
							options={this.props.listaTipo}
							label='Ocorrência'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_tipo}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_tipo: values.map(item => item.value)
								});
							}} />

						<Select
							maxWidth={350}
							options={this.props.listaUsuario}
							label='Incluído por'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_usuario}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_usuario: values.map(item => item.value)
								});
							}} />

						<div style={{ width: 310, marginTop: 8, marginLeft: 8 }}>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
									this.props.getListaTipo();
									this.props.getListaMotorista();
									this.props.getListaGravidade();
									this.props.getListaLocal();
									this.props.getListaResponsabilidade();
									this.props.getListaTipoCusto();
									this.props.getListaStatusGestao();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {
										datahora_ocorrencia: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()), 
										quantidade: 1 
									});
									this.props.initForm({ 
										datahora_ocorrencia:  DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()),
										quantidade: 1 
									});
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								title='Adicionar múltiplos'
								onClick={() => {
									this.props.setModoTela('cadastro', { 
										multiplos: true, 
										datahora_ocorrencia: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()), 
										quantidade: 1 
									});
									this.props.initForm({ 
										multiplos: true, 
										datahora_ocorrencia:  DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()), 
										quantidade: 1 
									});
								}}>
								<i class='fas fa-list-ol'></i> Múltiplos
							</a>

							<ExcelFile
								filename={'Ocorrências'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									data_admissao_motorista: DateFormat.formatarDataSqlParaTela(item.data_admissao_motorista),
									datahora_ocorrencia: DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia),
									percentual_desconto: FormatUtils.formatarValorTela(item.percentual_desconto, 2),
									datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao),
									datahora_pagamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_pagamento),
									custo: FormatUtils.formatarValorTela(item.custo, 2),
									valor: FormatUtils.formatarValorTela(item.valor, 2),
									valor_autorizado: FormatUtils.formatarValorTela(item.valor_autorizado, 2)
								}))} name='Premiação'>
									<ExcelColumn label='Data/Hora' value='datahora_ocorrencia' />
									<ExcelColumn label='Motorista' value='nome_motorista' />
									<ExcelColumn label='Ocorrência' value='nome_tipo' />
									<ExcelColumn label='Perc. Desconto' value='percentual_desconto' />
									<ExcelColumn label='Observação' value='observacao' />
									<ExcelColumn label='Usuário Inclusão' value='nome_usuario_inclusao' />
									<ExcelColumn label='Abona' value='abona' />
									<ExcelColumn label='Status' value='nome_status_gestao' />
								</ExcelSheet>
							</ExcelFile>

						</div>
					</Row>

					<div 
						style={{ 
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 340}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 260}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 260}px`
										: `${window.innerHeight - 190}px`
									)
								)
							)
						}}>
						<Table responsive border striped alturaFixa 
							maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 340}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 260}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 260}px`
										: `${window.innerHeight - 190}px`
									)
								)
							)}>
							<THead>
								<Tr backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { datahora_ocorrencia: this.getNovaOrdenacao(this.state.ordenacao.datahora_ocorrencia) }})} 
										sticky width={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Data/Hora {this.getIconeOrdenacao(this.state.ordenacao.datahora_ocorrencia)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_motorista: this.getNovaOrdenacao(this.state.ordenacao.nome_motorista) }})} 
										sticky width={200} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Motorista {this.getIconeOrdenacao(this.state.ordenacao.nome_motorista)}</Th>
									<Th paddingTop={2} paddingBottom={2}
										onClick={() => this.setState({ ...this.state, ordenacao: { data_admissao_motorista: this.getNovaOrdenacao(this.state.ordenacao.data_admissao_motorista) } })}
										sticky width={40} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Admissão {this.getIconeOrdenacao(this.state.ordenacao.data_admissao_motorista)}</Th>
									<Th paddingTop={2} paddingBottom={2}
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_tipo: this.getNovaOrdenacao(this.state.ordenacao.nome_tipo) }})}
										sticky width={200} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Ocorrência {this.getIconeOrdenacao(this.state.ordenacao.nome_tipo)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { percentual_desconto: this.getNovaOrdenacao(this.state.ordenacao.percentual_desconto) }})} 
										sticky width={80} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Percentual de Desconto'>% Desc. {this.getIconeOrdenacao(this.state.ordenacao.percentual_desconto)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { observacao: this.getNovaOrdenacao(this.state.ordenacao.observacao) }})} 
										sticky width={300} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Observação {this.getIconeOrdenacao(this.state.ordenacao.observacao)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_usuario_inclusao: this.getNovaOrdenacao(this.state.ordenacao.nome_usuario_inclusao) }})} 
										sticky width={200} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Usuário Inclusão {this.getIconeOrdenacao(this.state.ordenacao.nome_usuario_inclusao)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { abona: this.getNovaOrdenacao(this.state.ordenacao.abona) }})} 
										sticky width={80} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Abona {this.getIconeOrdenacao(this.state.ordenacao.abona)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_status_gestao: this.getNovaOrdenacao(this.state.ordenacao.nome_status_gestao) }})} 
										sticky width={80} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Status {this.getIconeOrdenacao(this.state.ordenacao.nome_status_gestao)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										sticky width={50} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Ações'></Th>
								</Tr>
							</THead>
							<TBody>
								{lista.map((item, i) => (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td minWidth={100} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia)}</Td>
										<Td minWidth={200} color={'#000'} alignCenter small>{item.nome_motorista}</Td>
										<Td  minWidth={40} color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_admissao_motorista)}</Td>
										<Td minWidth={200} color={'#000'} alignCenter small>{item.nome_tipo}</Td>
										<Td minWidth={80} color={'#000'} alignCenter small>{FormatUtils.formatarValorTela(item.percentual_desconto, 2)}</Td>
										<Td minWidth={300} color={'#000'} alignCenter small>{item.observacao}</Td>
										<Td minWidth={200} color={'#000'} alignCenter small>{item.nome_usuario_inclusao}</Td>
										<Td minWidth={80} color={'#000'} alignCenter small>{item.abona ? 'SIM' : 'NÃO'}</Td>
										<Td minWidth={120} color={'#000'} alignCenter small>{item.nome_status_gestao}</Td>
										<Td minWidth={50} alignCenter>
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={true}
												small
												event={() => {
													this.props.setModoTela('cadastro', {
														...item,
														percentual_desconto: FormatUtils.formatarValorTela(item.percentual_desconto, 2),
														datahora_ocorrencia: DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia),
														datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao),
														datahora_pagamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_pagamento),
														custo: FormatUtils.formatarValorTela(item.custo, 2),
														valor: FormatUtils.formatarValorTela(item.valor, 2),
														valor_autorizado: FormatUtils.formatarValorTela(item.valor_autorizado, 2)
													});
													this.props.initForm({
														...item,
														percentual_desconto: FormatUtils.formatarValorTela(item.percentual_desconto, 2),
														datahora_ocorrencia: DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia),
														datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao),
														datahora_pagamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_pagamento),
														custo: FormatUtils.formatarValorTela(item.custo, 2),
														valor: FormatUtils.formatarValorTela(item.valor, 2),
														valor_autorizado: FormatUtils.formatarValorTela(item.valor_autorizado, 2)
													});
												}} />

											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={true}
												small
												event={() => {
													this.props.setModoTela('exclusao', {
														...item,
														percentual_desconto: FormatUtils.formatarValorTela(item.percentual_desconto, 2),
														datahora_ocorrencia: DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia),
														datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao),
														datahora_pagamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_pagamento),
														custo: FormatUtils.formatarValorTela(item.custo, 2),
														valor: FormatUtils.formatarValorTela(item.valor, 2),
														valor_autorizado: FormatUtils.formatarValorTela(item.valor_autorizado, 2)
													});
													this.props.initForm({
														...item,
														percentual_desconto: FormatUtils.formatarValorTela(item.percentual_desconto, 2),
														datahora_ocorrencia: DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia),
														datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao),
														datahora_pagamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_pagamento),
														custo: FormatUtils.formatarValorTela(item.custo, 2),
														valor: FormatUtils.formatarValorTela(item.valor, 2),
														valor_autorizado: FormatUtils.formatarValorTela(item.valor_autorizado, 2)
													});
												}} />
										</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.ocorrencia.aguardando,
	modoTela: state.ocorrencia.modoTela,
	lista: state.ocorrencia.lista,
	listaCategoria: state.ocorrencia.listaCategoria,
	filtro: state.ocorrencia.filtroPrincipal,
	listaTipo: state.ocorrencia.listaTipo,
	listaMotorista: state.ocorrencia.listaMotorista,
	listaStatusGestao: state.ocorrencia.listaStatusGestao,
	listaUsuario: state.ocorrencia.listaUsuario,
	listaTipoOcorrrencia: state.ocorrencia.listaTipoOcorrrencia
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, 
	getListaTipo, getListaMotorista, getListaGravidade, getListaLocal, 
	getListaResponsabilidade, getListaTipoCusto, salvarAbona, 
	getListaStatus, getListaAcao, getListaUsuario, getListaCategoria, getListaStatusGestao
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Ocorrencia);
